import { render } from "./TheSearchBar.vue?vue&type=template&id=2dc86b01"
import script from "./TheSearchBar.vue?vue&type=script&lang=js"
export * from "./TheSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__